import { render, staticRenderFns } from "./startChapterExercise.vue?vue&type=template&id=52186849&scoped=true"
import script from "./startChapterExercise.vue?vue&type=script&lang=js"
export * from "./startChapterExercise.vue?vue&type=script&lang=js"
import style0 from "./startChapterExercise.vue?vue&type=style&index=0&id=52186849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52186849",
  null
  
)

export default component.exports